// NotificationProfileService.tsx
import { useInfiniteQuery } from '@tanstack/react-query';
import { PageSize } from '../../type';
import { NotificationProfileService } from '../../core/services';

export const useGetNotificationsService = (initialParams: PageSize) => {
  const { data, isLoading, error, refetch, fetchNextPage, hasNextPage, isFetchingNextPage, isFetching } =
    useInfiniteQuery({
      queryKey: ['get-notifications-list'],
      queryFn: async ({ pageParam }) => {
        return NotificationProfileService.getNotifications({
          page: initialParams.pageNumber ?? pageParam,
          size: initialParams.size,
          userId: initialParams.userId || '',
          type: initialParams.type || '',
        });
      },
      initialPageParam: 1,
      getNextPageParam: (res) => (!res?.last ? res?.number + 1 : undefined),
      enabled: false,
      retry: 1,
      retryDelay: 36000000,
    });
  const isDataFetching = isFetching || isFetchingNextPage;

  return {
    data,
    isLoading,
    error,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isDataFetching,
  };
};
